import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import { refreshToken } from '../api/refreshtoken.api';
import type {RootState} from './store';

interface feedbackState {
    access_token: string;
    loading: boolean;
    error: string;
  }
  const initialState: feedbackState = {
    access_token: '',
    loading: false,
    error: '',
  };



export const newAccessToken = createAsyncThunk(
  'newToken',
  async (parameters: string, thunkApi) => {
      return refreshToken(parameters)
        .then(response => {
          return response;
        })
        
        .catch(error => {
          return thunkApi.rejectWithValue(error.response.data);
        });
    
   
  },
);

export const refreshTokenSlice = createSlice({
    name: 'newToken',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
      resetState: () => initialState,
    },
    extraReducers: builder => {
      builder.addCase(newAccessToken.pending, state => {
        state.loading = true;
      });
      builder.addCase(newAccessToken.fulfilled, (state, action) => {
        state.loading = false;
        state.access_token=action.payload.access_token;
      });
      builder.addCase(newAccessToken.rejected, (state, action) => {
        console.log('action====>', action);
        state.error = action.toString();
  
        state.loading = false;
      });
    },
  });
  
  //Other code such as selectors can use the imported `RootState` type
  export const {resetState} = refreshTokenSlice.actions;
  
  
  export const refreshTokenError = (state: RootState): string => state.refreshTokenReducer.error;
  export const refreshTokenLoading = (state: RootState): boolean =>
    state.refreshTokenReducer.loading;
    export const refreshNewToken = (state: RootState): string =>
    state.refreshTokenReducer.access_token;
  
    export default refreshTokenSlice.reducer;
